import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions'; //eslint-disable-line no-unused-vars
import FileUpload from '../api/fileUploadApi';
import * as types from './actionTypes';

export function fileSubmissionSuccess(fileSubmission) {
  return {type: types.FILE_SUBMISSION_SUCCESS, fileSubmission};
}

export function uploadFile(fileContents, fileName) {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return FileUpload.uploadFile(fileContents, fileName).then(response => {
      dispatch(fileSubmissionSuccess(response));
      return response;
    }).catch(error => {
      dispatch(startAjaxCallError(error));
      throw error;
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/fileUploadActions.js
 **/